export var DEFAULT_THEME = 'light';